<template>
  <div class="order-detail m-t-20">
    <div class="page-title">订单详情</div>

    <div class="p-20 flex">
      <div class="m-r-30">订单号：{{ shoppingOrder.code }}</div>
      <div>下单时间：{{ timeInfo.buyTime }}</div>
    </div>

    <div class="info-card flex col-stretch">
      <!-- 收货信息 -->
      <div class="receipt divider-section">
        <div class="divider-section__title">收货信息</div>
        <jczh-descriptions
          :info="receiptInfo"
          :option="receiptInfoOption"
          :el-attrs="{
            column: 1
          }"
          label-width="60px"
        />
      </div>
      <!-- 配送信息 -->
      <div class="delivery divider-section">
        <div class="divider-section__title">配送信息</div>
        <jczh-descriptions
          :info="deliveryInfo"
          :option="deliveryInfoOption"
          :el-attrs="{
            column: 1
          }"
          label-width="60px"
        />
      </div>
      <!-- 订单备注 -->
      <div class="remark divider-section">
        <div class="divider-section__title">订单备注</div>
        <jczh-descriptions
          :info="buyerInfo"
          :option="buyerInfoOption"
          :el-attrs="{
            column: 1
          }"
        />
      </div>
    </div>

    <!-- 商品订单列表 -->
    <div v-for="shopOrder in shoppingOrder.shopOrders" :key="shopOrder.orderId">
      <div class="p-20">
        <span>订单号：{{ shopOrder.code || '-' }}</span>
        <span class="m-l-20">
          店铺：{{ (shopOrder.shopInfo || {}).name || '-' }}
        </span>
      </div>
      <order-table
        :table-head="tableHead"
        :table-data="[transShopOrderToOrder(shopOrder)]"
        :show-order-header="false"
      />
    </div>

    <!-- 订单费用汇总信息 -->
    <div class="order-total flex-col col-bottom p-r-20">
      <div
        v-for="item in orderTotalOption"
        :key="item.label"
        class="total-info flex row-between"
      >
        <span class="total-info-label">{{ item.label }}</span>
        <span :class="{ important: item.important }" class="total-info-value">
          {{ parsePrice(item.value) }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import OrderTable from './OrderTable/OrderTable.vue'
import { strToThousands } from '@/utils/utils'
import { getOrderDetailApi } from '@/api/mall'

function parsePrice(value, prefix = '￥') {
  return prefix + strToThousands(Number(value)?.toFixed(2))
}

export default {
  name: 'OrderManagementId',

  components: { OrderTable },

  props: {
    requestQuery: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      shoppingOrder: {},
      order: {},

      receiptInfoOption: [
        { label: '收件人', prop: 'receiver' },
        { label: '联系方式', prop: 'mobile' },
        { label: '收货地址', prop: 'address' }
      ],
      deliveryInfoOption: [
        { label: '配送方式', prop: 'deliveryMethod' },
        {
          label: '运费',
          prop: 'shippingFee',
          filter: value => parsePrice(value)
        }
      ],
      buyerInfoOption: [
        { label: '买家姓名', prop: 'buyerName' },
        {
          label: '买家留言',
          prop: 'remark',
          filter: value => value || '暂无'
        }
      ],

      tableHead: [
        { label: '商品', component: 'ProductCell', prop: 'productInfo' },
        {
          label: '单价',
          prop: 'productInfo.productSkuPrice',
          width: '200px',
          isPrice: true
        },
        {
          label: '数量',
          prop: 'productInfo.buyCount',
          width: '200px',
          filter: value => `x${value}`
        },
        {
          label: '总额',
          prop: 'actualMoney',
          width: '200px',
          isPrice: true
        }
      ]
    }
  },

  computed: {
    timeInfo() {
      return this.order.timeInfo || {}
    },

    // 收货信息
    receiptInfo() {
      const addressInfo = this.order.addressInfo || {}
      return {
        receiver: addressInfo.receiverName,
        mobile: addressInfo.receiverPhone,
        address:
          addressInfo.receiverProvince +
          addressInfo.receiverCity +
          addressInfo.receiverDistrict +
          (addressInfo.receiverAddress || '')
      }
    },

    // 配送信息
    deliveryInfo() {
      return {
        // 配送方式
        deliveryMethod: '普通快递',
        // 运费
        shippingFee: this.order.moneyInfo?.freight || 0
      }
    },

    // 买家信息
    buyerInfo() {
      return {
        buyerName: this.order.addressInfo?.receiverName,
        remark: this.order.orderInfo?.remark || '-'
      }
    },

    // 订单费用展示配置列表
    orderTotalOption() {
      return [
        {
          label: '商品总额',
          value: this.shoppingOrder.moneyInfo?.productTotalPrice || 0
        },
        {
          label: '商品运费',
          value: this.shoppingOrder.moneyInfo?.freight || 0
        },
        {
          label: '实付金额',
          value: this.shoppingOrder.moneyInfo?.actualMoney || 0,
          important: true
        }
      ]
    },

    // 订单日志
    logList() {
      return this.order.logs || []
    }
  },

  watch: {
    'requestQuery.orderId': {
      handler: function(val) {
        val && this.getOrderDetail(val)
      },
      immediate: true
    }
  },

  methods: {
    parsePrice,

    getOrderDetail(orderId) {
      getOrderDetailApi(orderId)
        .then(res => {
          this.shoppingOrder = res.data || {}
          this.order =
            this.shoppingOrder.shopOrders?.length > 0
              ? this.shoppingOrder.shopOrders[0] || {}
              : {}
        })
        .catch(err => {
          if (err?.message) this.$message.error(err.message)
        })
    },

    /**
     * 将后台数据转换成OrderTable组件识别的数据
     */
    transShopOrderToOrder(shopOrder) {
      return {
        ...shopOrder,
        orderId: shopOrder.orderId,
        orderCode: shopOrder.code,
        orderStatus: shopOrder.status,
        createTime: shopOrder.timeInfo?.buyTime,
        shopId: shopOrder.shopInfo?.shopId,
        shopName: shopOrder.shopInfo?.name
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.order-detail {
  background-color: $white-color;
}
.page-title {
  padding: 10px 20px;
  border-radius: 2px;
  background: $info-fourth-color;
  @include text-bold;
  font-size: 16px;
}

.info-card {
  width: 100%;
  background-color: $white-color;
  border: 1px solid $info-fourth-color;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
  padding: 20px;

  .divider-section {
    min-width: 200px;
    max-width: 50%;
    padding: 0 30px;
    border-right: 1px solid $info-fourth-color;

    &:first-child {
      padding-left: 0;
    }

    &:last-child {
      border-right: none;
    }

    .divider-section__title {
      color: $text-color;
      @include text-bold;
      margin-bottom: 20px;
    }
  }
}

.order-total {
  margin-top: 20px;
  text-align: right;

  .total-info {
    width: 300px;
    line-height: 40px;

    .total-info-label {
      &::after {
        content: '：';
      }
    }

    .total-info-value {
      &.important {
        font-size: 16px;
        color: $danger-color;
        @include text-bold;
      }
    }
  }
}

.log-section {
  padding-top: 20px;
  border-top: 2px dashed $info-fourth-color;

  .log-title {
    font-size: 16px;
    color: $text-color;
    @include text-bold;
    margin-bottom: 10px;
  }

  .log-content {
    .log-item {
      color: $second-text-color;
      line-height: 32px;

      span {
        &:not(:last-child) {
          margin-right: 10px;
        }
      }
    }
  }
}
</style>
